import React, { useEffect, useMemo, useState } from "react";
import {
	Box,
	Dialog,
	List,
	ListItemButton,
	ListItemText,
	TextField,
	Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { filterTerms } from "./terminologyUtils";

const MAX_RESULTS = 12;

const CommandPalette = ({ open, onClose, terms, onPick }) => {
	const { t } = useTranslation();
	const [query, setQuery] = useState("");
	const [highlight, setHighlight] = useState(0);

	useEffect(() => {
		if (open) {
			setQuery("");
			setHighlight(0);
		}
	}, [open]);

	const matches = useMemo(
		() => filterTerms(terms, { query }).slice(0, MAX_RESULTS),
		[terms, query]
	);

	const pick = (key) => {
		onPick(key);
		onClose();
	};

	const handleKeyDown = (e) => {
		if (e.key === "ArrowDown") {
			e.preventDefault();
			setHighlight((h) => Math.min(h + 1, matches.length - 1));
		} else if (e.key === "ArrowUp") {
			e.preventDefault();
			setHighlight((h) => Math.max(h - 1, 0));
		} else if (e.key === "Enter") {
			e.preventDefault();
			if (matches[highlight]) pick(matches[highlight].key);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<Box sx={{ p: 2 }}>
				<TextField
					autoFocus
					fullWidth
					size="small"
					placeholder={t("placeholder.jumpToTerm")}
					value={query}
					onChange={(e) => {
						setQuery(e.target.value);
						setHighlight(0);
					}}
					onKeyDown={handleKeyDown}
					inputProps={{ "aria-label": "Jump to term" }}
				/>

				{matches.length === 0 ? (
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ p: 2 }}
					>
						{t("message.noMatchingTerms")}
					</Typography>
				) : (
					<List dense sx={{ maxHeight: 360, overflowY: "auto" }}>
						{matches.map((term, index) => (
							<ListItemButton
								key={term.key}
								selected={index === highlight}
								onClick={() => pick(term.key)}
							>
								<ListItemText
									primary={term.effectiveSingular}
									secondary={term.key}
								/>
							</ListItemButton>
						))}
					</List>
				)}
			</Box>
		</Dialog>
	);
};

export default CommandPalette;
